import "./ErrorFallback.css";

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <div role="alert" className="error-fallback">
            <h2>Something went wrong</h2>
            <pre className="error-message">{error.message}</pre>
            <button onClick={resetErrorBoundary} className="error-button">
                Try Again
            </button>
        </div>
    );
}

export default ErrorFallback;
